import React from 'react';
import { Banner as BannerNew } from './Banner';
import { convertOldBannerProps } from './converter.old';
import type { BannerKind, OldBannerProps } from './converter.old';

export type { BannerDirection, BannerSize, BannerStatus } from './Banner';
export type { BannerKind };
export type BannerProps = OldBannerProps;

export const Banner = (props: BannerProps) => <BannerNew {...convertOldBannerProps(props)} />;
